import { useSuspenseQuery } from "@apollo/client";
import { PrimaryFullScreenSpinner } from "@repo/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { graphql } from "~/gql/client";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/")({
  head: () => opsHead("Dashboard"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  const { data } = useSuspenseQuery(
    graphql(`
      query OpsDashboard {
        appEnvironment {
          id
          metabaseToken
        }
      }
    `),
  );

  if (!window.metabaseConfig?.instanceUrl || !window.metabaseConfig.isGuest) {
    window.metabaseConfig = {
      isGuest: true,
      instanceUrl: "https://stats.primary.tech",
    };
  }

  return (
    <div className="-m-6">
      <metabase-dashboard
        token={data?.appEnvironment?.metabaseToken ?? undefined}
        with-title="false"
        with-downloads="true"
        className="block h-dvh w-full"
        style={{ display: "block", height: "100vh" }}
      />
    </div>
  );
}
